import * as yup from 'yup';
import { API as products } from '../../products/api';
import _ from 'lodash';
import { AvailableType, QuantityType } from '../../listItem/conf/Data.conf';

const Conf = {
  schema: yup.object({
    available: yup.object().nullable().required('Available is required'),
    quantity: yup.string().nullable().required('Quantity is required'),
    quantity_type: yup.object().nullable().required('Type is required'),
    id_item: yup.object().nullable().required('Product is required'),
    category: yup.object().nullable(),
    note: yup.string().nullable(),
    internal_note: yup.string().nullable(),
    attachment: yup.mixed().nullable(),
  }),
  defaultValues: {
    available: _.find(AvailableType, ['id', 'NEW ITEM']),
    quantity: '',
    quantity_type: null,
    id_item: null,
    note: '',
    category: null,
    internal_note: '',
    attachment: null,
  },
  fields: [
    {
      id: 'id_item',
      name: 'id_item',
      type: 'async_autocomplete',
      label: 'Product',
      api: products.selectPRV,
      required: true,
      xs: 12,
      sm: 6,
      autoFocus: true,
    },
    {
      id: 'quantity',
      name: 'quantity',
      type: 'number',
      label: 'Quantity',
      xs: 12,
      sm: 2,
      md: 1.5,
      required: true,
    },
    {
      id: 'quantity_type',
      name: 'quantity_type',
      type: 'autocomplete',
      label: 'Type',
      options: QuantityType,
      xs: 12,
      sm: 2,
      md: 2,
      required: true,
    },
    {
      id: 'available',
      name: 'available',
      type: 'autocomplete',
      label: 'Available',
      options: AvailableType,
      required: true,
      xs: 12,
      sm: 3,
      md: 2.5,
    },
    {
      id: 'note',
      name: 'note',
      type: 'text_multiline',
      label: 'Note',
      xs: 12,
      rows: 2,
    },
    {
      id: 'internal_note',
      name: 'internal_note',
      type: 'text',
      label: 'Internal Note',
      xs: 12,
    },
    {
      id: 'attachment',
      name: 'attachment',
      label: 'Photo',
      type: 'upload',
      xs: 12,
      sm: 6,
      md: 4,
    },
    {
      id: 'selected_item_preview',
      type: 'selected_item_preview',
      label: 'Selected product details',
      watchField: 'id_item',
      xs: 12,
    },
  ],
};

export const CreateConf = {
  default: { ...Conf },
  hasLogbook: {
    schema: Conf.schema,
    defaultValues: {
      ...Conf.defaultValues,
      available: _.find(AvailableType, ['id', 'ORDERED']),
    },
    fields: Conf.fields,
  },
};
